import React, {Component} from 'react'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import AUSelectGenerator from '../auto_updaters/ValidSelect'
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import Loading from '../Loading'

const OfficeSelect = AUSelectGenerator('offices', 'id description', 'id', ['description'])

export default class NotificationInput extends Component {

  constructor(props) {
    super(props)
    this.state = {...props}
  }

  render(){

    const {title, saving, loading, isOpen, toggle, id, subject, message, office_id, popup, onChange, onSave} = this.props

    if(loading){
      return (
        <Modal isOpen={isOpen} size="lg">
          <ModalHeader>{title}</ModalHeader>
          <ModalBody>
              <Loading/>
          </ModalBody>
      </Modal>
      )
    }

    return (
      
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <AvForm onValidSubmit={() => onSave(this.props)}>
          <ModalHeader>{title}</ModalHeader>
          <ModalBody>
            
              <AvField
                required
                bsSize="sm"
                errorMessage="Required"
                name="subject"
                label="Subject *"
                placeholder="Subject"
                value={subject}
                onChange={(evt) => onChange({key: 'subject', value: evt.target.value})}
              />
              <AvField
                required
                bsSize="sm"
                style={{height: '25em'}}
                type="textarea"
                errorMessage="Required"
                name="message"
                label="Message *"
                value={message}
                onChange={(evt) => onChange({key: 'message', value: evt.target.value})}
              />
              <OfficeSelect
                bsSize="sm"
                name="office"
                label="Office (Leave Blank For All Offices)"
                value={office_id}
                onChange={(office_id) => onChange({key: 'office_id', value: office_id})}
              />
              <AvField
                type="checkbox"
                name="popup"
                label="Make Notification Pop Up"
                value={popup}
                onChange={(evt) => onChange({key: 'popup', value: evt.target.checked})}
              />
            
          </ModalBody>
          <ModalFooter>
          <Button size="sm" color="success" disabled={saving}>
            <FontAwesomeIcon
                color="#fff"
                icon={saving ? 'spinner' : 'save'}
                spin={saving}
            />{' '}
            {saving ? 'Saving...' : 'Save'}
          </Button>
          </ModalFooter>
        </AvForm>
      </Modal>
      
      
    )
  }
}